import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { isNullOrUndefined } from 'util';
import { JournalInsertModel, tJournalModel } from 'src/app/models/tJournalModel';
import {tRecurrJnlModel}from 'src/app/models/tRecurrJnlModel';
import {tRecurrJnlService} from 'src/app/services/tRecurrJnl.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-voucher-save',
  templateUrl: './voucher-save.component.html',
  styleUrls: ['./voucher-save.component.css']
})
export class VoucherSaveComponent implements OnInit {
  TAG = "VoucherSaveComponent";
  @Input() dataSubmit: JournalInsertModel[];
  saveData:tRecurrJnlModel[]=new Array();
  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private recurrJnlService:tRecurrJnlService,
    private apiResultDialogService: ApiResultDialogService,
    public datePipe: DatePipe,
  ) { }

  get f() { return this.editForm.controls; }
  editForm: FormGroup;
  today = new Date(); 
  onClick=false;
  submitted = false;

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      jnlDate: this.datePipe.transform(this.today, 'yyyy-MM-dd'),
      recurrName: ['', [Validators.required]],

    });
    this.changeJournalToRecurr();
  }
  cancel() {
    this.log.i(this.TAG, 'do cancel');
    this.activeModal.close('Close click');
  }
  confirm(){

    this.submitted = true;
    this.log.i(this.TAG,this.editForm.get('recurrName').value);
    if(this.onClick==false){
      this.onClick=true;
    if (this.editForm.valid) {


    
      var text=this.editForm.get('recurrName').value;
      this.log.i(this.TAG, text);
      this.inputRecurrName(text);
   
      this.recurrJnlService.newJournal(this.saveData).subscribe((data:any) => {
        this.log.i(this.TAG, 'onSubmit success: ' + JSON.stringify(data));
        let returnDisplayMsg: string;
  
        this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
          returnDisplayMsg = res;
        });
        returnDisplayMsg+= " - "+data.data;
        this.cancel();
        this.onClick=false;
        this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_YNDialog, null, status, returnDisplayMsg);
        //this.router.navigate([AppSettings.Path_Journal]);
      },
        err => {
          this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
          this.onClick=false;
        });


    }else{
      var displayMsg = '';
      this.translate.get('alert_input_text').subscribe((res: string) => {
        displayMsg = res;
        this.onClick=false;
      });

      alert(displayMsg);
    }
  }
  }
  changeJournalToRecurr(){

    
    for(let i=0; i < this.dataSubmit.length; i++){
      var pushData:tRecurrJnlModel=new tRecurrJnlModel();
      
      pushData.acctNo=this.dataSubmit[i].acctNo;
      pushData.analysis1=this.dataSubmit[i].analysis1;
      pushData.analysis2=this.dataSubmit[i].analysis2;
      pushData.chequeNo=this.dataSubmit[i].chequeNo;
      pushData.crAmtBase=this.dataSubmit[i].crAmtBase;
      pushData.crAmtFC=this.dataSubmit[i].crAmtFC;
      pushData.drAmtBase=this.dataSubmit[i].drAmtBase;
      pushData.drAmtFC=this.dataSubmit[i].drAmtFC;
      pushData.lineNo=this.dataSubmit[i].lineNo;
      pushData.refNo=this.dataSubmit[i].refNo;
      pushData.shopID=this.dataSubmit[i].shopID;
      pushData.vendorNo=this.dataSubmit[i].vendorNo;
      pushData.empNo=this.dataSubmit[i].empNo;
      pushData.hdrRemark=this.dataSubmit[i].hdrRemark;
      pushData.exRate=this.dataSubmit[i].exRate;
      pushData.vouType=this.dataSubmit[i].vouType;
      pushData.currCode=this.dataSubmit[i].currCode;
      pushData.jnlDate=this.dataSubmit[i].jnlDate;
      pushData.lineRemark=this.dataSubmit[i].lineRemark;

      this.saveData.push(pushData);
    }
  }
  inputRecurrName(recurrName:string){


    for(let i = 0; i < this.saveData.length; i++){
      this.saveData[i].recurrName=recurrName;
    }
  }

}
